import { LoadingButton } from '@mui/lab';
import { Divider, Dialog, DialogTitle, DialogContent, DialogActions, Button, Grid, Typography, Box, useMediaQuery, Tooltip } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useLazyGetWalletBalanceQuery, useTransactionWalletMutation } from 'src/_api/mapitShipApi';
import { useLazyGetSubscriptionInfoQuery } from 'src/_api/planApi';
import { SelectAmountCard } from 'src/_modules/MapitShip/views/AccountBalance/components';
import { setSubscriptionInfo } from 'src/_store/entities/creditsAndSubscription';
import { setCredits } from 'src/_store/entities/creditsAndSubscription';
import { closeCreditsBalancDialog } from 'src/_store/entities/creditsAndSubscription';

export default function CreditsBalanceNotEnoughDialog() {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { open, title, content, isShippingCompanyNotHaveEnoughCredits } = useSelector((state) => state.entities.creditsAndSubscription)

    const chargeValues = [100, 500, 1000, 2000, 5000]

    //======= Charge Wallet =========

    const [chargeWallet, {
        isLoading: chargeWalletLoading,
        error: chargeWalletError,
        isSuccess: chargeWalletIsSuccess
    }] = useTransactionWalletMutation()

    const onConfirm = async (value) => {
        try {
            const totaLCharge = Number((value + (value * 0.15)).toFixed(2))
            let response = await chargeWallet({ amount: totaLCharge, vat: value * 0.15, lastPageUrl: window.location.pathname }).unwrap()
            if (!!response?.url) {
                window.open(response?.url, "_self")
            }
        } catch (error) {
            console.log(error)
        }
    }

    const fullScreen = useMediaQuery(theme => theme.breakpoints.down('md'));

    const isLoading = chargeWalletLoading
    const error = chargeWalletError
    const isSuccess = chargeWalletIsSuccess

    const [getWalletBalance] = useLazyGetWalletBalanceQuery()
    const [getSubscriptionInfo] = useLazyGetSubscriptionInfoQuery()

    const [refreshLoading, setRefreshLoading] = useState(false)

    const refreshWalletHandler = async () => {
        try {
            setRefreshLoading(true)
            const wallet = await getWalletBalance().unwrap()
            const subscriptionInfo = await getSubscriptionInfo().unwrap()

            if (!!wallet) {
                dispatch(setCredits(wallet?.balance))
            }
            if (!!subscriptionInfo) {
                dispatch(setSubscriptionInfo(subscriptionInfo))
            }
            dispatch(closeCreditsBalancDialog());
        } catch (error) {
            console.log(error)
        } finally {
            setRefreshLoading(false)
        }
    }

    return (
        <Dialog
            open={open}
            onClose={(e) => e.preventDefault()}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            fullWidth
            maxWidth="md"
            fullScreen={fullScreen}
        >
            {!!title
                &&
                <>
                    <DialogTitle id="alert-dialog-title">
                        {t(title)}
                    </DialogTitle>
                    <Divider />
                </>
            }
            <DialogContent>
                {!!content && <Typography color="secondary" fontWeight="bold" sx={{ mb: 3 }}>{t(content)}</Typography>}
                {!isShippingCompanyNotHaveEnoughCredits &&
                    <Grid container spacing={2} alignItems="center">
                        <Grid item xs={12} sm={6} md={4} lg={3} key="CUSTOM">
                            <SelectAmountCard custom={true} onConfirm={onConfirm} loaidng={isLoading} />
                        </Grid>
                        {
                            chargeValues.map((value, index) => (
                                <Grid item xs={12} sm={6} md={4} lg={3} key={value}>
                                    <SelectAmountCard key={value} value={value} onConfirm={onConfirm} loaidng={isLoading} />
                                </Grid>
                            ))
                        }
                    </Grid>
                }
            </DialogContent>
            <Divider />
            <DialogActions>
                {/* {isSuccess && <Typography color="success.main">{t("Done successfully")}</Typography>} */}
                {!!error && <Typography color="error">{error}</Typography>}
                <Box mr="auto" />
                <LoadingButton
                    sx={{ textTransform: "none" }}
                    variant='contained'
                    loading={refreshLoading}
                    onClick={() => {
                        // if (typeof onClose === 'function') onClose();
                        dispatch(closeCreditsBalancDialog());
                    }}
                >
                    {t("Cancel")}
                </LoadingButton>
                {!isShippingCompanyNotHaveEnoughCredits &&
                    <Tooltip placement="top" title={t("Refresh wallet after recharging and retry create task again.")}>
                        <LoadingButton
                            sx={{ textTransform: "none" }}
                            variant='outlined'
                            onClick={refreshWalletHandler}
                            loading={refreshLoading}
                        >
                            {t("Refresh Wallet")}
                        </LoadingButton>
                    </Tooltip>
                }
            </DialogActions>
        </Dialog>
    );
}

// import { LoadingButton } from '@mui/lab';
// import { Divider, Dialog, DialogTitle, DialogContent, DialogActions, Typography, Box, useMediaQuery, Tooltip } from '@mui/material';
// import { useState } from 'react';
// import { useTranslation } from 'react-i18next';
// import { useDispatch, useSelector } from 'react-redux';
// import { useLazyGetWalletBalanceQuery } from 'src/_api/mapitShipApi';
// import { useLazyGetSubscriptionInfoQuery } from 'src/_api/planApi';
// import { ChargeWalletWithAmount } from 'src/_modules/MapitShip/views/AccountBalance/components';
// import { setSubscriptionInfo } from 'src/_store/entities/creditsAndSubscription';
// import { setCredits } from 'src/_store/entities/creditsAndSubscription';
// import { closeCreditsBalancDialog } from 'src/_store/entities/creditsAndSubscription';

// export default function CreditsBalanceNotEnoughDialog() {
//     const { t } = useTranslation();
//     const dispatch = useDispatch();
//     const { open, title, content, isShippingCompanyNotHaveEnoughCredits } = useSelector((state) => state.entities.creditsAndSubscription)

//     //======= Charge Wallet =========

//     const fullScreen = useMediaQuery(theme => theme.breakpoints.down('md'));

//     const [getWalletBalance] = useLazyGetWalletBalanceQuery()
//     const [getSubscriptionInfo] = useLazyGetSubscriptionInfoQuery()

//     const [refreshLoading, setRefreshLoading] = useState(false)

//     const refreshWalletHandler = async () => {
//         try {
//             setRefreshLoading(true)
//             const wallet = await getWalletBalance().unwrap()
//             const subscriptionInfo = await getSubscriptionInfo().unwrap()

//             if (!!wallet) {
//                 dispatch(setCredits(wallet?.balance))
//             }
//             if (!!subscriptionInfo) {
//                 dispatch(setSubscriptionInfo(subscriptionInfo))
//             }
//             dispatch(closeCreditsBalancDialog());
//         } catch (error) {
//             console.log(error)
//         } finally {
//             setRefreshLoading(false)
//         }
//     }

//     return (
//         <Dialog
//             open={open}
//             onClose={(e) => e.preventDefault()}
//             aria-labelledby="alert-dialog-title"
//             aria-describedby="alert-dialog-description"
//             fullWidth
//             maxWidth="md"
//             fullScreen={fullScreen}
//         >
//             {!!title
//                 &&
//                 <>
//                     <DialogTitle id="alert-dialog-title">
//                         {t(title)}
//                     </DialogTitle>
//                     <Divider />
//                 </>
//             }
//             <DialogContent>
//                 {!!content && <Typography color="secondary" fontWeight="bold" sx={{ mb: 3 }}>{t(content)}</Typography>}
//                 {!isShippingCompanyNotHaveEnoughCredits &&
//                     <ChargeWalletWithAmount
//                         chargeValues={[100, 500, 1000, 2000, 5000]}
//                     />
//                 }
//             </DialogContent>
//             <Divider />
//             <DialogActions>
//                 <Box mr="auto" />
//                 <LoadingButton
//                     sx={{ textTransform: "none" }}
//                     variant='contained'
//                     loading={refreshLoading}
//                     onClick={() => {
//                         // if (typeof onClose === 'function') onClose();
//                         dispatch(closeCreditsBalancDialog());
//                     }}
//                 >
//                     {t("Cancel")}
//                 </LoadingButton>
//                 {!isShippingCompanyNotHaveEnoughCredits &&
//                     <Tooltip placement="top" title={t("Refresh wallet after recharging and retry create task again.")}>
//                         <LoadingButton
//                             sx={{ textTransform: "none" }}
//                             variant='outlined'
//                             onClick={refreshWalletHandler}
//                             loading={refreshLoading}
//                         >
//                             {t("Refresh Wallet")}
//                         </LoadingButton>
//                     </Tooltip>
//                 }
//             </DialogActions>
//         </Dialog>
//     );
// }
